export const BASE = "/";

export const SYSTEM_ADMIN_WORKSPACES = "/workspaces";
export const SYSTEM_ADMIN_USERS = "/users";
export const SYSTEM_ADMIN_LICENSE = "/license";
export const SYSTEM_ADMIN_SECURITY = "/security";

export const USER_ADMIN_USERS = "/users";
export const USER_ADMIN_LICENSE = "/license";

export const DICTIONARIES_HOME = "/";
export const getDictionaryPath = (id) => `/${id}`;
export const NEW_DICTIONARY = "/new_dictionary";
